import React,{ createContext, useState, useEffect } from "react";

const AuthContext = createContext();

function  AuthContextProvider({children}) {
    const [authToken, setAuthToken] = useState("");
    const [userDetails, setUserDetails] =  useState({})
  // Set token
  useEffect(() => {
    let token = localStorage.getItem("authToken");
    let userData =  JSON.parse(localStorage.getItem("authUser"));
    setAuthToken(token);
    setUserDetails(userData)
  }, []);


  return (
    <AuthContext.Provider value={{ authToken, userDetails }}>
      {children}
    </AuthContext.Provider>
  )
}

export { AuthContext, AuthContextProvider}
